angular.module('BookingApp')
.value 'KaligoSearch', {
  form: null,
  originLocale: null,
  currentLocale: null,
}
